import { graphql } from '../__generated__/gql';

export const GET_ALL_EVENTS = graphql(/* GraphQL */ `
  query AllEvents {
    allEvents {
      assetId
      eventDescription
      eventId
      eventStartDate
      eventEndDate
      eventScopeFreezeDate
      revisionCode
      updatedAt
      eventType
      isArchived
    }
  }
`);

export const GET_EVENTS_BY_ASSET = graphql(/* GraphQL */ `
  query AssetEvents($assetId: Int!) {
    eventsByAssetId(assetId: $assetId) {
      assetId
      eventDescription
      eventId
      eventStartDate
      eventEndDate
      eventScopeFreezeDate
      revisionCode
      eventType
      isArchived
    }
  }
`);

export const CREATE_EVENT = graphql(/* GraphQL */ `
  mutation CreateEvent($input: EventInput!) {
    createEvent(input: $input) {
      eventId
    }
  }
`);
